import React from 'react';
import { Box, Grid, Stack, Typography, TypographyProps, SxProps, IconButton, Tooltip } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTheme } from "@mui/material/styles";

type WidgetCardContainerProps = {
	title?: string | Array<string> | React.ReactNode;
	bgColor?: string;
	sx?: SxProps;
	mainSx?: SxProps;
	children: React.ReactNode;
	hasInsights?: boolean;
	onInsightsClick?: () => void;
	titleSx?: SxProps;
};

type TitleTypographyProps = TypographyProps & {
	title: string;
	titleSx?: SxProps;
};

const TitleTypography: React.FC<TitleTypographyProps> = ({ title, titleSx, ...rest }) => {
	const theme = useTheme();
	return (
	<Typography sx={{...titleSx}} variant="subHeader" fontFamily="Montserrat" color= {theme.palette.textLight.main} {...rest}>
		{title}
	</Typography>
)};

const WidgetCardContainer: React.FC<WidgetCardContainerProps> = ({ title, bgColor = 'blue.dark', children, sx, mainSx, hasInsights, onInsightsClick, titleSx }) => {
	const renderTitle = () => {
		console.log("typeof title", title);
		
		if (typeof title === 'string') {
			return <TitleTypography title={title} titleSx={titleSx}/>;
		} else if (Array.isArray(title)) {
			return title.map((t, idx) => (
				<React.Fragment key={`${t}-${idx}`}>
					<TitleTypography title={t} titleSx={titleSx}/>
					{idx < title.length - 1 && <ChevronRightIcon />}
				</React.Fragment>
			));
		} else {
			return title;
		}
	};

	return (
		<Box display="flex" flexGrow={1} height="100%" sx={mainSx}>
			<Stack bgcolor={bgColor} borderRadius="5px" flexGrow={1} sx={{ p: 2, ...sx }}>
				{!!title && (
					<Stack direction="row" alignItems="center" justifyContent="space-between" mb={1.5}>
						<Box display="inline-flex" flexDirection="row" alignItems="center">
							{renderTitle()}
						</Box>
						{hasInsights && onInsightsClick && (
							<Tooltip title="View Insights" arrow>
								<IconButton onClick={onInsightsClick} size="small" sx={{ color: 'white.main', p: 0.5 }}>
									<InfoOutlinedIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						)}
					</Stack>
				)}
				<Grid container spacing={1} flexGrow={1}>
					{children}
				</Grid>
			</Stack>
		</Box>
	);
};

export default WidgetCardContainer;
